import { Box, Text } from '@chakra-ui/react';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { hoverElement } from '../../redux/hoverElementSlice';

const HoverOverlay = () => {
	const { componentId, componentName, isCanvas } = useSelector(hoverElement);
	const [pos, setPos] = React.useState({ x: 0, y: 0, w: 0, h: 0 });
	const updateScroll = _.debounce(handleScroll, 100);

	function handleScroll() {
		const htmlElement = document.querySelector(`[data-selection="${componentId}"]`);

		let el;
		if (htmlElement) {
			el = htmlElement;
		} else if (htmlElement?.parentElement) {
			el = htmlElement.parentElement;
		}
		const width = el?.offsetWidth;
		const height = el?.offsetHeight;
		const rect = el?.getBoundingClientRect();
		const finalPos = { x: rect?.left ?? 0, y: rect?.top ?? 0, w: width ?? 0, h: height ?? 0 };
		setPos(finalPos);
	}

	React.useEffect(() => {
		const element = document.getElementsByClassName('canvas-iframe')[0] ?? document.getElementsByClassName('canvas')[0];
		if (!componentId || !element) return;
		// handleScroll(true)
		if (isCanvas) {
			handleScroll();
		} else {
			element.addEventListener('scroll', updateScroll);
		}
		return () => element.removeEventListener('scroll', updateScroll);
	}, [componentId, componentName]);

	if (!componentId || (pos.w == 0 && pos.h == 0)) return null;

	return (
		<Box
			pointerEvents={'none'}
			className="hover-overlay"
			position={'fixed'}
			h={pos.h + 'px'}
			w={pos.w + 'px'}
			top={pos.y + 'px'}
			left={pos.x + 'px'}
			zIndex="9990"
			border="3px solid blue"
		>
			<Text
				color={'white'}
				fontSize={'12px'}
				bg="blue"
				float={'left'}
				p={'0 4px'}
				w={'fit-content'}
				top={0}
				left={0}
				right={'auto'}
			>
				{componentName}
			</Text>
		</Box>
	);
};

export default HoverOverlay;
